import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {QUESTION__24, NEW_WINDOW__16} from '@homeaway/svg-defs';

import PropTypes from 'prop-types';
import translate from '../../../utils/translations';
import './HelpCenter.less';
export class HelpCenter extends React.Component {
    static propTypes = {
        humanReadableBrandName: PropTypes.string.isRequired,
    };

    static defaultProps = {
        translations: {},
        humanReadableBrandName: '',
    };

    render() {
        const {translations, humanReadableBrandName} = this.props;

        return (
            <div className="HelpCenter rounded-border HelpCenter__text-align">
                <span className="HelpCenter__wrapper-title">
                    <SVGIcon
                        usefill
                        markup={QUESTION__24}
                        className="HelpCenter__question-icon"
                    />
                    <h2 className="HelpCenter__wrapper-text">
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.details.help-center.title',
                            {brandName: humanReadableBrandName}
                        )}
                    </h2>
                </span>
                <p className="HelpCenter__padding-body">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.details.help-center.description',
                        {brandName: humanReadableBrandName}
                    )}
                </p>
                <span className="HelpCenter__padding-body">
                    <a
                        href={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.confirmation.faq.ctaLink'
                        )}
                    >
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.details.help-center.link',
                            {brandName: humanReadableBrandName}
                        )}
                        <SVGIcon
                            usefill
                            markup={NEW_WINDOW__16}
                            className="HelpCenter__window-icon"
                        />
                    </a>
                </span>
            </div>
        );
    }
}
